import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_PARAMETER} from '../../constants';

export default {
  id: 'GESTION_INVIT',
  title: 'Comment gérer l’accès à mon dossier ?',
  description: '',
  categories: [CONTENT_CATEGORY_PARAMETER],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Depuis l’onglet « Paramètres » de votre entreprise, vous pouvez choisir de gérer automatiquement ou manuellement la mise à disposition de vos documents à vos clients.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Cochez ou décochez le bouton, puis valider.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_GESTION_INVIT/FR_GESTION_INVIT.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Si vous faites le choix de gérer manuellement la mise à disposition de vos documents, vos clients ne pourront pas accéder instantanément à votre dossier. Vous devrez donc valider chaque invitation.'
  }]
};
